var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "media-library-item",
    {
      staticClass: "media-library-file",
      attrs: {
        "name-editor-placeholder": _vm.resource(
          "MediaLibrary_RenameFile_Placeholder"
        ),
        name: _vm.name
      },
      on: {
        "item-clicked": function($event) {
          return _vm.$emit("file-selected")
        },
        "item-double-clicked": function($event) {
          return _vm.$emit("file-picked")
        },
        "item-renamed": function($event) {
          return _vm.rename($event)
        }
      }
    },
    [_c("file-icon", { attrs: { name: this.name, size: "3x" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }